// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1lIrt","large":"styles_large__1nuof"};